import { message } from 'antd'
import Layout from 'container/Layout'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import {
	Clients,
	SingleClient,
	Dashboard,
	Templates,
	Template,
	Invoices,
	Payments,
	Login,
	Admins,
	Forgotpassword,
	Broadcasts,
	Pricing,
	PulseRelease,
	AgentAppRelease,
} from 'pages'
import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { logoutAction } from 'slices/auth'
import SingleBroadcast from 'pages/SingleBroadcast'
import PlatformSelector from 'container/PlatformSelector'
import Wallet from 'pages/Wallet'
import Subscriptions from 'pages/Subscriptions'

const Router = () => {
	const dispatch = useAppDispatch()

	const { isAuthenticated } = useAppSelector(state => state.auth)

	const forceLogout = () => {
		message.error({
			content: 'Your session has expired. Please login again.',
			key: 'session-expired',
		})
		dispatch(logoutAction())
	}

	useEffect(() => {
		window.addEventListener('sessionExpired', forceLogout)
		return () => {
			window.removeEventListener('sessionExpired', forceLogout)
		}
	}, [isAuthenticated])

	return (
		<Routes>
			{isAuthenticated && (
				<Route path='/' element={<Layout />}>
					<Route index element={<Navigate to='/clients' replace />} />
					<Route path='dashboard' element={<Dashboard />} />
					<Route path='clients' element={<Clients />} />
					<Route path='clients/:id' element={<SingleClient />} />
					<Route path='templates' element={<Templates />} />
					<Route path='templates/:id' element={<Template />} />
					<Route path='invoices' element={<Invoices />} />
					<Route path='wallet' element={<Wallet />} />
					<Route path='payments' element={<Payments />} />
					<Route path='pricing' element={<Pricing />} />
					<Route path='admins' element={<Admins />} />
					<Route path='broadcasts' element={<Broadcasts />} />
					<Route path='broadcasts/:id' element={<SingleBroadcast />} />
					<Route path='subscriptions' element={<Subscriptions />} />
					<Route path='pulse-release' element={<PulseRelease />} />
					<Route path='agent-app-release' element={<AgentAppRelease />} />
				</Route>
			)}
			{!isAuthenticated && (
				<>
					<Route path='/' element={<PlatformSelector />} />
					<Route path='/login' element={<Login />} />
					<Route path='/forgot-password' element={<Forgotpassword />} />
				</>
			)}
			<Route
				path='*'
				element={<Navigate to={isAuthenticated ? '/clients' : '/'} replace />}
			/>
		</Routes>
	)
}

export default Router
